mutation DeletePricelist($id: ID!) {
    deletePricelist(id: $id)
}
